{
  "feedback-emotion-page": {
    "text": {
      "title": "Votre avis",
      "subtitle": "Aidez-nous à améliorer notre service",
      "dissatisfied": "Insatisfait",
      "on": "à la",
      "neutral": "Neutre",
      "satisfaction-question": "Êtes-vous satisfait de notre service ?",
      "satisfied": "Satisfait",
      "thanks": "Merci de votre visite",
      "tip": "Conseil : Cliquez sur l'icône du visage pour montrer à quel point vous êtes satisfait de notre service"
    }
  }
}
